import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Webcam } from '../models/webcam.model';


@Injectable({
  providedIn: 'root'
})
export class WebcamService {
  constructor(private _http: HttpClient,
              private _errorHandler: ErrorHandler) { }

  /**
   * updates specified entity via api
   * @param {number} businessID
   * @param {Webcam} webcam
   * @return {Promise<any>}
   */
  putWebcam(businessID: number, webcam: Webcam): Promise<any> {
    const URL = `${environment.airportsApiUrl}/business/${businessID}/webcam/${webcam.webcamId}`;
    try {
      const BODY = this._getWebcamJSON(webcam);
      return this._http.put(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * adds specified entity via api
   * @param {number} businessID
   * @param {Webcam} webcam
   * @return {Promise<any>}
   */
  postWebcam(businessID: number, webcam: Webcam): Promise<any> {
    const URL = `${environment.airportsApiUrl}/business/${businessID}/webcam/`;
    try {
      const BODY = this._getWebcamJSON(webcam);
      return this._http.post(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * deletes specified entity via api
   * @param {number} airportID
   * @param {number} webcamID
   * @return {Promise<any>}
   */
  deleteWebcam(businessID: number, webcamID: number): Promise<any> {
    const URL = `${environment.airportsApiUrl}/business/${businessID}/webcam/${webcamID}`;
    try {
      return this._http.delete(URL).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * converts entity to json obj
   * @param {Webcam} webcam
   * @return {any}
   * @private
   */
  _getWebcamJSON (webcam: Webcam): any {
    return {
      name: webcam.name,
      site: webcam.site,
      url: webcam.url,
      direction: webcam.direction,
      operatedBy: 'Business'
    };
  }
}
